export const QUESTIONS_PER_PAGE = 10;
export const RESULTS_STORAGE_KEY = "results";
